import { useStyles } from '../../../hooks/useStyles';
import { FloatingCardsLayout } from '../../layout/FloatingCardsLayout';
import { FloatingCardContent } from '../../layout/cards/FloatingCardContent';
import { ConsumptionReports } from '../../reports/consumptionReport/ConsumptionReports';
import ReportsSharedWrapper from './ReportsSharedWrapper';

function ConsumptionReportsPage() {
  const { theme } = useStyles();

  return (
    <FloatingCardsLayout
      content={
        <FloatingCardContent
          flexible
          gap={theme.sizing.scale600}
        >
          <ReportsSharedWrapper>
            <ConsumptionReports />
          </ReportsSharedWrapper>
        </FloatingCardContent>
      }
      contentSize={550}
    />
  );
}

export default ConsumptionReportsPage;
